import React from "react";
import { BadgeDollarSign, ShieldCheck, LineChart, Globe2 } from "lucide-react";

const CARDS = [
  {
    icon: BadgeDollarSign,
    title: "Best Price",
    desc: "Live auctions push suppliers to compete — so you secure the lowest market price every time.",
    color: "blue",
  },
  {
    icon: ShieldCheck,
    title: "Quality Control",
    desc: "Only verified manufacturers with certifications and proven production capacity are onboarded.",
    color: "red",
  },
  {
    icon: LineChart,
    title: "Market Insights",
    desc: "Real-time commodity pricing, trend analytics and benchmarks — right on your dashboard.",
    color: "blue",
  },
  {
    icon: Globe2,
    title: "Global Supplier Network",
    desc: "Access verified manufacturers and exporters from multiple regions through one unified sourcing platform.",
    color: "red",
  },
];

export default function CommoditiesSection() {
  return (
    <section
      id="commodities"
      data-testid="commodities-section"
      className="relative py-20 md:py-28 bg-slate-50/60"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center reveal">
          <h2
            data-testid="commodities-title"
            className="font-display font-black text-3xl md:text-5xl text-slate-900 leading-tight tracking-tight"
          >
            What are Commodities?
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            Commodities are basic goods and raw materials — oil, grains, metals,
            chemicals — traded globally based on price. CommodityBid makes
            sourcing them easy, transparent, and cost-efficient.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            const isBlue = c.color === "blue";
            return (
              <div
                key={c.title}
                data-testid={`commodity-card-${i}`}
                className="reveal group relative bg-white rounded-2xl p-6 border border-slate-200/70 hover:border-blue-300 hover:-translate-y-1 transition-all duration-300 shadow-sm hover:shadow-xl"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${
                    isBlue
                      ? "bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white"
                      : "bg-red-50 text-red-500 group-hover:bg-red-500 group-hover:text-white"
                  } transition-colors duration-300`}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <h3 className="font-display font-extrabold text-lg text-slate-900 mb-2">
                  {c.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
